import { matchesSearch, duplicateInfo } from './tankSearch';

// Tab categories for the tank management page (vector 2026-10-06). Every tank lands in exactly
// one of the six categories (priority order below), so the six counts always sum to the total.
// Classified by status + whether a customer is linked — never by the free-text "route" column
// (legacy rows have route "โรงงาน" with a customer still attached).
export const CATEGORY_TABS = [
    { key: 'shop', label: 'อยู่กับร้าน' },
    { key: 'factory', label: 'อยู่โรงงาน' },
    { key: 'lent', label: 'ให้ยืม' },
    { key: 'lost', label: 'หาย / กำลังตาม' },
    { key: 'nodata', label: 'ไม่มีข้อมูล' },
    { key: 'gone', label: 'ยกให้ / ชำรุด' },
    { key: 'all', label: 'ทั้งหมด' },
];

export const TAB_KEYS = CATEGORY_TABS.map((t) => t.key);

export const categorize = (tank) => {
    const status = tank?.status;
    // Lent out (temple / event / shop): not at the factory even when no customer is linked.
    if (status === 'LENT') return 'lent';
    if (status === 'NO_DATA') return 'nodata';
    if (status === 'LOST' || status === 'SEARCHING') return 'lost';
    if (status === 'DONATED' || status === 'DAMAGED') return 'gone';
    // ACTIVE / RETURNED / anything else: where it physically is = whether a customer holds it.
    return tank?.customerCode ? 'shop' : 'factory';
};

export const matchesTab = (tank, tab) => tab === 'all' || categorize(tank) === tab;

export const countByCategory = (tanks) => {
    const counts = { shop: 0, factory: 0, lent: 0, lost: 0, nodata: 0, gone: 0, all: 0 };
    (tanks || []).forEach((t) => {
        counts[categorize(t)] += 1;
        counts.all += 1;
    });
    return counts;
};

// status equals, has-customer, route contains ci — where "route" is the route(s) of the shop holding the
// tank (routesByCustomer: customer code → route names), not the free-text label on the tank row —
// plus the free-text search box (number / code year / shop name) and the duplicates-only toggle.
export const applyFilters = (tanks, { status, hasCustomer, route, routesByCustomer, query, onlyDuplicates }) => {
    const r = (route || '').trim().toLowerCase();
    const dups = onlyDuplicates ? duplicateInfo(tanks) : null;
    return (tanks || []).filter((t) => {
        if (!matchesSearch(t, query)) return false;
        if (dups && !dups.isDuplicate(t)) return false;
        if (status && t.status !== status) return false;
        if (hasCustomer === 'true' && !t.customerCode) return false;
        if (hasCustomer === 'false' && t.customerCode) return false;
        if (r) {
            const names = (t.customerCode && routesByCustomer && routesByCustomer[t.customerCode]) || [];
            if (!names.some((n) => n.toLowerCase().includes(r))) return false;
        }
        return true;
    });
};
